import { InjectionToken } from '@angular/core';
import { IEnvironment } from '../interfaces/environment.interface';

export const MAXBRAIN_ENVIRONMENT = new InjectionToken<IEnvironment>('MAXBRAIN_ENVIRONMENT');
